import React, { useCallback } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import { useShortcuts, useShortcutsActions } from '../controllers/shortcuts-service/index.tsx';
import Modal from './modal/index.tsx';

const Dialog = () => {
	const [, { setShortcutsDialogVisibility }] = useShortcutsActions();
	const onClose = useCallback(
		() => setShortcutsDialogVisibility(false),
		[setShortcutsDialogVisibility],
	);
	return (
		<ContextualAnalyticsData sourceName="dotDialog" sourceType={MODAL}>
			<Modal onClose={onClose} />
			<FireScreenAnalytics attributes={{ name: 'dotDialog' }} />
		</ContextualAnalyticsData>
	);
};

const ShortcutsDialog = () => {
	const [{ isShortcutsDialogVisible }] = useShortcuts();

	return isShortcutsDialogVisible ? (
		<JSErrorBoundary id="shortcuts-dialog" packageName="jira-shortcuts-dialog" fallback="unmount">
			<Dialog />
		</JSErrorBoundary>
	) : null;
};

export default ShortcutsDialog;
